import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export const InlineField = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <Box display="flex" alignItems="flex-start" py={0.5}>
    <Typography
      variant="body1"
      color="textSecondary"
      style={{ minWidth: 100, flexShrink: 0 }}
    >
      {label}
    </Typography>
    <Box flex={1} minWidth={0} display="flex" alignItems="center">
      {children}
    </Box>
  </Box>
);
